import { PhongMaterial } from "@xeokit/xeokit-sdk";

const setupSAOShadow = (viewer) => {
  const sao = viewer.scene.sao;

  if (!sao.supported) {
    console.warn("SAO is not supported on this system.");
  } else {
    sao.enabled = true; // Enable SAO
    sao.intensity = 0.2; // Shadow intensity
    sao.bias = 0.5; // Bias to reduce shadow artifacts
    sao.scale = 1.0; // Scaling for shadow size
    sao.minResolution = 0.0; // Minimum resolution for shadow
    sao.numSamples = 10; // Number of samples
    sao.kernelRadius = 100; // Radius of shadow sampling
    sao.blendCutoff = 0.1; // Cutoff for blending
  }

    new PhongMaterial(viewer.scene, {
        color: [0.6, 0.6, 0.6], // Neutral light gray
        shininess: 50, // Reflectiveness
        castShadow: true, // Enable shadow casting
        receiveShadow: true, // Enable shadow receiving
  });
  

};

export default setupSAOShadow;